import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Actualiza el código de barras mostrado al cambiar la variante del producto.
 */
class ProductMetafieldsGrid extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"]');
    target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"]');
    target?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /** @param {Event} event */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = String(event.detail.data.newProduct.id);
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const span = this.querySelector('[data-pdp-barcode]');
    const cell = span?.closest('.pdp-mf-cell');
    if (!span) return;

    const barcode = event.detail.resource?.barcode ?? '';
    if (barcode) {
      span.textContent = barcode;
      if (cell instanceof HTMLElement) cell.hidden = false;
    } else {
      span.textContent = '';
      if (cell instanceof HTMLElement) cell.hidden = true;
    }
  };
}

if (!customElements.get('product-metafields-grid')) {
  customElements.define('product-metafields-grid', ProductMetafieldsGrid);
}
